export default "__VITE_ASSET__BtzFyWZz__"